/*
 * Renders agent search cards and their inquiry action.
 * The inquiry control must not navigate while the modal opens.
 */
import app from 'apprun';
import { __, lang } from '../Txlat';
import { getAgentLink, getAgencyLinkById } from '../utility';
import InqueryTitle from '../agent-inquiry-title';

export default function ({ agent, hightlight }) {
  const inqueryTitle = <InqueryTitle agent1={agent} agent2='' />;
  const emailSubject = `${__('Inquiry posted at rlpCommercial.com')}`;
  return (
    <div class={hightlight ? 'item-listing-wrap hz-item-gallery-js card list-view' : 'item-listing-wrap hz-item-gallery-js card '} data-images="" style={hightlight ? 'border:3px solid red; width:100%; padding: 3px 5px; margin-bottom: 10px;' : 'padding: 3px 5px;margin-bottom: 10px;'}>
      <div class="item-wrap item-wrap-v1 item-wrap-no-frame h-100">
        <div class="d-flex align-items-center h-100" style={hightlight ? 'flex-direction:row' : ''}>
          <div class="item-header" style="width:auto;">
            <div class="listing-image-wrap">
              <div class="listing-thumb">
                <a target={'agent' + agent.id} href={getAgentLink(agent)} class="listing-featured-thumb hover-effect">
                  <img width="180" src={agent.photo_path} class="img-fluid wp-post-image" alt="" loading="lazy" style="width:180px !important; object-fit: cover;object-position:0 0; max-width: 100%; cursor: pointer; " />		</a>
              </div>
            </div>
            <div class="preview_loader"></div>
          </div>
          <div class="item-body flex-grow-1" style={hightlight ? 'width:auto;' : ''}>
            <div class="pt-2">
              <div class="float-right">
                {hightlight && <a $onclick="close-highlighed-card" style="position: absolute; right: 20px; top: 0px; cursor:pointer;color: red;font-size: 20px;font-weight: bold;">×</a>}
              </div>
            </div>
            <ul class="item-amenities item-amenities-with-icons">
              <li>
                <h2 class="item-title" style="white-space: normal;overflow: visible;">
                  <a target={'agent' + agent.id} href={getAgentLink(agent)}><b>{agent.name}</b></a>
                </h2>
              </li>
            </ul>

            {(agent.title && agent.title !== '' || agent.title_FR && agent.title_FR !== '') ?
              <ul class="item-amenities item-amenities-with-icons">
                <li>{lang.get() === 'en' ? agent.title : agent.title_FR}</li>
              </ul>
              : ''}

            {(agent.officeName && agent.officeName !== '') ?
              <ul class="item-amenities item-amenities-with-icons">
                <li class='item-title' style="white-space: normal; overflow: visible;"><a target={'agency' + agent.office_id} href={getAgencyLinkById(agent.office_id)}><b>{agent.officeName}</b></a></li>
              </ul>
              : ''}

            <ul class="item-amenities item-amenities-with-icons">
              <li>{agent.address}</li>
            </ul>

            <ul class="item-amenities item-amenities-with-icons">
              <li>{(agent.city || '').toUpperCase()}&nbsp;{(agent.province || '').toUpperCase()}&nbsp;{(agent.postal_code || '').toUpperCase()}</li>
            </ul>

            <ul class="item-amenities item-amenities-with-icons">
              {(agent.mobile && agent.mobile !== '') ? <li><strong>{__('Mobile')}:</strong> <a href={'tel:' + agent.mobile}><span class="agent-phone ">{agent.mobile}</span></a></li> : ''}
            </ul>

            <ul class="item-amenities item-amenities-with-icons">
              {(agent.phone && agent.phone !== '') ? <li><strong>{__('Office')}:</strong> <a href={'tel:' + agent.phone}><span class="agent-phone ">{agent.phone}</span></a></li> : ''}
            </ul>

            <ul class="item-amenities item-amenities-with-icons">

              <div class="d-flex flex-row">
                <div class="flex-grow-1">
                  <button type="button" class="btn btn-search btn-secondary " style='line-height:30px;color:white;' $onclick={['/openInqueryModal', { inqueryTitle, email: agent.email, inquiryType: 'AgentInquiry', sub: emailSubject, agent1: agent, form_type: 'AgentProfile', formName: 'agentSearch' }]}>{__('Contact agent')}</button>
                </div>
                <div class="mobile-switch">
                  <a onclick={() => app.run('/openMarker', agent.name)}><img height="30" src='/wp-content/themes/houzez/img/map/pin-agent.png' style="height:30px; cursor: pointer;" /></a></div>
              </div>
            </ul>

          </div>
        </div>
      </div>
    </div>

  );
}
